// Seedable RNG (mulberry32). Deterministic under a fixed seed so VS-AI matches
// can be reproduced in unit tests. AS2's `random(n)` semantics (integer in
// [0, n-1]) are reproduced by `int()`.

export class RNG {
  private a: number;

  constructor(seed: number) {
    this.a = seed >>> 0;
  }

  /** Float in [0, 1). */
  next(): number {
    this.a |= 0;
    this.a = (this.a + 0x6d2b79f5) | 0;
    let t = Math.imul(this.a ^ (this.a >>> 15), 1 | this.a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }

  /** Integer in [0, n-1] — mirrors ActionScript2 `random(n)`. */
  int(n: number): number {
    return Math.floor(this.next() * n);
  }

  /** Integer in [min, max] inclusive. */
  range(min: number, max: number): number {
    return min + this.int(max - min + 1);
  }

  pick<T>(items: readonly T[]): T {
    return items[this.int(items.length)];
  }

  chance(p: number): boolean {
    return this.next() < p;
  }
}

/** A non-deterministic seed for casual play (still routed through mulberry32). */
export function randomSeed(): number {
  return (Math.random() * 0xffffffff) >>> 0;
}
